/*
 * @Auther: 罗耀祖
 * @Date: 2021-07-23 17:29:49
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-04-20 17:22:47
 * @name: 商品权限对象
 * @Description: 商品权限对象
 * @FilePath: \preSaleNafterSaleBackstage\src\object\transform\jurisdiction.class.js
 * @Author: DESKTOP-1QU67QM
 */
import { getCatagoryGoods, agencyGoodsGetGoods } from "@/api/pianoCompanyManage/pianoCompanyManage.api.js";
import { apiMethod } from '@/utils/decorator.js';

const jurisdiction = class jurisdiction {
  constructor() {
    this.catagoryGoods = []; //商品权限-列表
    this.treeDataGet = []; //选中的树节点信息数组
    this.is_change = 0; //选中的树节点信息数组是否进行删除操作
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 获取商品权限列表
   */
  @apiMethod(getCatagoryGoods)
  getCatagoryGoods(res) {
    if (res.code === 200) {
      this.catagoryGoods = res.data.map(x => {
        return {
          union_id: x.id,
          id: x.id,
          level: x.level,
          name: x.category_name,
          disabled: !x.child || x.child.length === 0,
          children: (!x.child || x.child.length === 0) ? [] : x.child.map(y => {
            return {
              union_id: y.parent_id + '-' + y.id,
              id: y.id,
              level: y.level,
              brand_id: y.parent_id,
              name: y.category_name,
              disabled: !y.child || y.child.length === 0,
              children: (!y.child || y.child.length === 0) ? [] : y.child.map(z => {
                return {
                  union_id: x.id + '-' + y.id + '-' + z.id,
                  id: z.id,
                  level: z.level,
                  brand_id: x.id,
                  series_id: y.id,
                  name: z.category_name,
                  disabled: !z.goods || z.goods.length === 0,
                  children: (!z.goods || z.goods === 0) ? [] : z.goods.map(t => {
                    let levels = [];
                    t.sku.forEach(s => {
                      levels = levels.concat(s.level);
                    })
                    return {
                      union_id: x.id + '-' + y.id + '-' + z.id + '-' + t.id,
                      id: t.id,
                      level: 4,
                      brand_id: x.id,
                      series_id: y.id,
                      model_id: z.id,
                      name: t.goods_name + '-' + t.color.color,
                      levels,
                      select: '',
                    }
                  })
                }
              })
            }
          })
        }
      });
    }
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 删除节点
   * @param {Object} e
   */
  removeNode(e) {
    this.treeDataGet.splice(this.treeDataGet.findIndex(y => y.union_id === e.union_id), 1); //变为未选状态
    this.is_change++;
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 获取全名称
   * @param {Number} id 商品id
   * @return {String} 商品全名称
   */
  getFullName(item) {
    let name = '';
    let brand = this.catagoryGoods.find(x => x.id === item.brand_id);
    let brand_name = brand.name;
    let series = brand.children.find(x => x.id === item.series_id);
    let series_name = series.name;
    let model = series.children.find(x => x.id === item.model_id);
    let model_name = model.name;
    let goods_name = item.name;
    name = brand_name + '-' + series_name + '-' + model_name + '-' + goods_name;
    return name;
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 获取原有权限
   * @param {Stirng} id 琴行id
   */
  @apiMethod(agencyGoodsGetGoods)
  getDefault(res) {
    if (res.code === 200) {
      let def = [];
      res.data.forEach(x => {
        let obj = {
          union_id: (x.goods?.parent?.parent?.parent?.id ?? '') + '-' + (x.goods?.parent?.parent?.id ?? '') + '-' + (x.goods?.parent.id ?? '') + '-' + (x.goods?.id ?? ''),
          brand_id: x.goods?.parent?.parent?.parent?.id ?? '',
          id: x.goods?.id ?? '',
          leaf: true,
          level: 4,
          levels: x.level?.map(y => {
            y.goods_sku_id = x.goods_sku_id;
            return y;
          }) ?? [],
          model_id: x.goods?.parent.id ?? '',
          name: x.goods?.goods_name + '-' + x.goods?.color,
          series_id: x.goods?.parent?.parent?.id ?? '',
          select: x.goods_level_id,
        }
        def.push(obj);
      })
      this.treeDataGet = this.treeDataGet.concat(def);
      this.is_change++;
    }
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 选中商品变化
   * @param {String} arr 变化后的选中商品
   */
  checkNodeChange(arr) {
    let addArr = arr.filter(x => this.treeDataGet.findIndex(y => y.union_id === x.union_id) === -1); //新增的商品
    let reduceArr = this.treeDataGet.filter(x => arr.findIndex(y => y.union_id === x.union_id) === -1); //删除商品
    addArr = addArr.map(x => {
      // 新增的商品默认赋予第一个级别
      x.select = x.levels[0].id;
      return x;
    })
    //先删掉需删掉的商品
    reduceArr.forEach(x => {
      this.treeDataGet.splice(this.treeDataGet.findIndex(y => y.union_id === x.union_id), 1); //变为未选状态
    })
    //添加需添加的商品
    this.treeDataGet = this.treeDataGet.concat(addArr);
  }
}

export default jurisdiction;